import styles from './CTA.module.css'
import useReveal from '../hooks/useReveal.js'

export default function CTA() {
  const [ref, visible] = useReveal(0.3)

  return (
    <section className={styles.section} id="post-role">
      <div ref={ref} className={`container ${styles.inner} ${visible ? styles.visible : ''}`}>
        <h2 className={styles.heading}>Ready to hire smarter?</h2>
        <p className={styles.text}>
          Tell us about the role today and get your first AI-matched
          shortlist within 48 hours — no obligation, no upfront fee.
        </p>
        <div className={styles.actions}>
          <a href="mailto:michael@virtual-recruiter.com" className={styles.primary}>
            Post a role
          </a>
          <a href="tel:+64276655450" className={styles.secondary}>
            Or call Michael on +64 27-665-5450
          </a>
        </div>
      </div>
    </section>
  )
}
